import { z } from 'zod';

import { UserSchema } from '../users/user';

/**
 * The token pair. `expiresIn` is seconds of access-token life, so a client can
 * schedule a refresh instead of discovering expiry through a failed request.
 *
 * The refresh token is returned in the body rather than set as a cookie: the
 * primary client is a native app with no cookie jar, and the admin SPA stores
 * it the same way, so there is one code path (W4's `baseQueryWithAuth`).
 */
export const TokenPairSchema = z.object({
  accessToken: z.string().min(1),
  refreshToken: z.string().min(1),
  expiresIn: z.number().int().positive(),
});

export type TokenPair = z.infer<typeof TokenPairSchema>;

/** What register and login return: the session, plus who it belongs to. */
export const AuthSessionSchema = z.object({
  tokens: TokenPairSchema,
  user: UserSchema,
});

export type AuthSession = z.infer<typeof AuthSessionSchema>;
